/* NIGHT OPERATORS video grid. Built 2026-09-28 by lane YOUTUBE-VIDEOS.
   Lite embed: nothing from YouTube loads until a card is pressed, and then it
   loads on the youtube-nocookie domain. One delegated listener for the page,
   so a section added by the theme editor works without a rebind.
   No em or en dashes in this file. */
(function () {
  'use strict';

  var ID_OK = /^[A-Za-z0-9_-]{6,20}$/;

  function play(button) {
    var id = button.getAttribute('data-video-id') || '';
    if (!ID_OK.test(id)) return;
    if (button.getAttribute('data-no-vgrid-loaded') === 'true') return;
    button.setAttribute('data-no-vgrid-loaded', 'true');

    var iframe = document.createElement('iframe');
    iframe.className = 'no-vgrid__iframe';
    iframe.src =
      'https://www.youtube-nocookie.com/embed/' +
      encodeURIComponent(id) +
      '?autoplay=1&rel=0&playsinline=1';
    iframe.setAttribute('title', button.getAttribute('aria-label') || 'YouTube video');
    iframe.setAttribute(
      'allow',
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
    );
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('loading', 'eager');

    button.textContent = '';
    button.appendChild(iframe);
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var button = target.closest('[data-no-vgrid-play]');
      if (!button) return;
      event.preventDefault();
      play(button);
    },
    false
  );
})();
